// extracted by mini-css-extract-plugin
export default {"content-empty":"index_content-empty__zczSi","icon":"index_icon__ixCyG","text":"index_text__vSXQ+","btn":"index_btn__-dKGu"};